var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 4.72806V13.3334C29.1667 14.5001 29.1667 15.0835 29.3937 15.5292C29.5935 15.9212 29.9122 16.2399 30.3042 16.4396C30.7498 16.6667 31.3332 16.6667 32.5 16.6667H41.1053M41.6667 20.8088V35.8334C41.6667 39.3337 41.6667 41.0838 40.9855 42.4208C40.3863 43.5968 39.4301 44.5529 38.2541 45.1521C36.9172 45.8334 35.167 45.8334 31.6667 45.8334H18.3333C14.833 45.8334 13.0829 45.8334 11.7459 45.1521C10.5699 44.5529 9.61376 43.5968 9.01455 42.4208C8.33334 41.0838 8.33334 39.3337 8.33334 35.8334V14.1667C8.33334 10.6664 8.33334 8.91619 9.01455 7.57925C9.61376 6.40323 10.5699 5.4471 11.7459 4.8479C13.0829 4.16669 14.833 4.16669 18.3333 4.16669H25.0245C26.5532 4.16669 27.3176 4.16669 28.0369 4.33938C28.6746 4.49248 29.2843 4.74501 29.8435 5.08769C30.4742 5.4742 31.0147 6.01467 32.0956 7.09562L38.7377 13.7378C39.8187 14.8187 40.3592 15.3592 40.7457 15.9899C41.0884 16.5491 41.3409 17.1588 41.494 17.7965C41.6667 18.5158 41.6667 19.2801 41.6667 20.8088Z",
    stroke: "#BFD4F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 16,
    fill: "#0052D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 42.5V43.5C47.5 44.9001 47.5 45.6002 47.2275 46.135C46.9878 46.6054 46.6054 46.9878 46.135 47.2275C45.6002 47.5 44.9001 47.5 43.5 47.5H36.5C35.0999 47.5 34.3998 47.5 33.865 47.2275C33.3946 46.9878 33.0122 46.6054 32.7725 46.135C32.5 45.6002 32.5 44.9001 32.5 43.5V42.5M44.1667 36.6667L40 32.5M40 32.5L35.8333 36.6667M40 32.5V42.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.cb287ea0be34ae329fc68561e6b18acc.svg";
export { ForwardRef as ReactComponent };